import { SearchQueryTerm } from '../types';

export enum SearchRegexQueryParserErrorCode {
  MALFORMED_QUERY = 'MALFORMED_QUERY',
  QUERY_CONTAINS_INVALID_REGEXP = 'QUERY_CONTAINS_INVALID_REGEXP',
  PARTIAL_QUERY = 'PARTIAL_QUERY',
  MISSING_CLOSING_PAREN = 'MISSING_CLOSING_PAREN',
  UNEXPECTED_CLOSING_PAREN = 'UNEXPECTED_CLOSING_PAREN',
}

export type SearchRegexQueryParserResult = {
  status?: 'valid' | 'invalid' | 'partial';
  errorCode?: SearchRegexQueryParserErrorCode;
  query: SearchQueryTerm[];
};

export enum SearchRegexQueryParserNodeSymbol {
  EOF = 'EOF',
  AND = 'AND',
  OR = 'OR',
  NOT = 'NOT',
  CRITERION = 'CRITERION',
  LPAREN = 'LPAREN',
  RPAREN = 'RPAREN',
}
